import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { API_URL, ENVIRONMENT, runHealthCheck } from "@/config/api";

// Log configuration
console.log(`[GC3H] Starting app - Environment: ${ENVIRONMENT}, API: ${API_URL}`);

// Run health check after app loads (non-blocking)
if (ENVIRONMENT !== 'development') {
  setTimeout(() => {
    runHealthCheck().then(result => {
      if (!result.success) {
        console.error(`[GC3H] Health check failed: ${result.error}`);
      }
    });
  }, 2000);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
